export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7111.53112376.jpg";